module.exports = __webpack_public_path__ + "img/mercado-livre.129985a5.png";